import {
  FaFilePdf, FaChevronDown, FaRegEdit, FaRegNewspaper, FaTrashAlt, FaFacebook,
  FaUpload, FaSearch, FaInstagram, FaYoutube, FaLinkedin, FaQuestionCircle,
  FaRegBell, FaPlus, FaRegStar, FaHome, FaRegTimesCircle, FaEye, FaEyeSlash, FaCheck, FaDownload 
} from "react-icons/fa";
import { FaCircleUser, FaArrowLeftLong } from "react-icons/fa6";
import { BiBookmarks } from "react-icons/bi";
import { RiShieldStarLine } from "react-icons/ri";
import { FaXTwitter, FaListCheck, FaArrowRight } from "react-icons/fa6";
import { ImCross } from "react-icons/im";
import { VscJson } from "react-icons/vsc";
import { LuListEnd } from "react-icons/lu";
import { IoMdWarning } from "react-icons/io";
import { FiLogOut, FiKey } from 'react-icons/fi';
import { GoGear } from "react-icons/go";
import { CiFilter } from "react-icons/ci";


const icons = {
  addlist: LuListEnd,
  arrow: FaChevronDown,
  bell: FaRegBell,
  bookmark: BiBookmarks,
  check: FaCheck,
  circlecross: FaRegTimesCircle,
  circleuser: FaCircleUser,
  cross: ImCross,
  default: FaQuestionCircle,
  download: FaDownload,
  edit: FaRegEdit,
  eye: FaEye,
  eyeslash: FaEyeSlash,
  facebook: FaFacebook,
  filter: CiFilter,
  gear: GoGear,
  home: FaHome,
  instagram: FaInstagram,
  json: VscJson,
  key: FiKey,
  leftlongarrow: FaArrowRight,
  linkedin: FaLinkedin,
  listcheck: FaListCheck,
  logout: FiLogOut,
  longarrowleft: FaArrowLeftLong,
  newspaper: FaRegNewspaper,
  pdf: FaFilePdf,
  plus: FaPlus,
  search: FaSearch,
  star: FaRegStar,
  starshield: RiShieldStarLine,
  trash: FaTrashAlt,
  upload: FaUpload,
  warning: IoMdWarning,
  xtwitter: FaXTwitter,
  youtube: FaYoutube,
};


export function Icon({ name, className }) {
  const IconComponent = icons[name?.toLowerCase()] || icons.default;
  return <IconComponent className={className} />;
}
